/**
 * RedisManagementService
 * Service for Redis cache management
 * Route: api/redismanagement
 */
import { BaseService } from '../base/BaseService';
export class RedisManagementService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? RedisManagementService.DEFAULT_SERVICE_PATH,
            basePath: RedisManagementService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    async getHealth() {
        const endpoint = this.getEndpoint('health', 'health');
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    async getStatistics() {
        const endpoint = this.getEndpoint('statistics', 'statistics');
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    async getConfiguration() {
        const endpoint = this.getEndpoint('configuration', 'configuration');
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    async clearByPattern(request) {
        const endpoint = this.getEndpoint('clear-by-pattern', 'clear-by-pattern');
        const url = this.buildUrl(endpoint);
        return this.http.post(url, request);
    }
    async clearAll(request) {
        const endpoint = this.getEndpoint('clear-all', 'clear-all');
        const url = this.buildUrl(endpoint);
        return this.http.post(url, request);
    }
    async scanKeys(params) {
        const endpoint = this.getEndpoint('keys-scan', 'keys/scan');
        const queryParams = new URLSearchParams();
        if (params?.pattern)
            queryParams.append('pattern', params.pattern);
        if (params?.pageSize)
            queryParams.append('pageSize', params.pageSize.toString());
        if (params?.cursor)
            queryParams.append('cursor', params.cursor.toString());
        const url = this.buildUrl(endpoint) + (queryParams.toString() ? `?${queryParams.toString()}` : '');
        return this.http.get(url);
    }
    async getKeysByService() {
        const endpoint = this.getEndpoint('keys-by-service', 'keys/by-service');
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    async getKeyMetadata(key) {
        const endpoint = this.getEndpoint('key-metadata', `keys/metadata/${encodeURIComponent(key)}`);
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    async previewPatternDeletion(request) {
        const endpoint = this.getEndpoint('preview-deletion', 'keys/preview-deletion');
        const url = this.buildUrl(endpoint);
        return this.http.post(url, request);
    }
    async getDomainStatistics() {
        const endpoint = this.getEndpoint('domain-statistics', 'statistics/by-domain');
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    async deleteKey(key) {
        const endpoint = this.getEndpoint('delete-key', `keys/${encodeURIComponent(key)}`);
        const url = this.buildUrl(endpoint);
        return this.http.delete(url);
    }
}
RedisManagementService.DEFAULT_SERVICE_PATH = 'system';
RedisManagementService.BASE_PATH = 'api/redismanagement';
//# sourceMappingURL=RedisManagementService.js.map